import React from 'react';
import Typography from '@material-ui/core/Typography';
import { Box, CardMedia, makeStyles } from '@material-ui/core';
import PostImages from './postImages';
import imgParams from '../../utils/imageUtil';
import { useDimensions } from '../../hooks/utilHooks';
import RichLinkPreview from './richLinkPreview';

const PostContent = ({ post, isPostDetail }) => {
  const classes = useStyles();
  const { width, ref } = useDimensions();

  return (
    <React.Fragment>
      {!post.isThemePost && (
        <Box className="cursorPointer">
          <Box whiteSpace="pre-line" pb={2} px={4}>
            <Typography
              className="checkPostHtml cursorPointer"
              variant="body1"
              color="textPrimary"
              component="span"
            >
              {post.description !== 'null' && (
                <div
                  dangerouslySetInnerHTML={{
                    __html: post.description,
                  }}
                ></div>
              )}
            </Typography>
          </Box>
          {post.isImagePost && post.images && post.images.length > 0 && (
            <PostImages
              postShareInfo={post.sharePostInfo}
              images={post.images}
              isPostDetail={isPostDetail}
              post={post}
            />
          )}
        </Box>
      )}

      {post.requestedUrl && <RichLinkPreview post={post} />}
      {post.isThemePost && post.themeImageUrl && (
        <Box pb={1} px={4} className="cursorPointer">
          <CardMedia
            ref={ref}
            className={classes.media}
            image={imgParams(post.themeImageUrl, width * 2)}
            alt="theme image"
          >
            <Box
              px={4}
              className={classes.themePostDescription}
              fontSize={post.themePostDescriptionFontSize}
              color={post.themePostDescriptionColor}
              component="div"
            >
              <div
                dangerouslySetInnerHTML={{
                  __html: post.description,
                }}
              ></div>
            </Box>
          </CardMedia>
        </Box>
      )}
    </React.Fragment>
  );
};

const useStyles = makeStyles((theme) => ({
  media: {
    width: '100%',
    height: '100%',
    borderRadius: theme.spacing(3),
  },
  themePostDescription: {
    height: '350px',
    lineHeight: '32px',
    alignItems: 'center',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
  },
}));

export default PostContent;
